export default __webpack_public_path__ + "aa4ed87e7f593275e94a511049f60990.svg";